import styled from "styled-components";

export const Container = styled.div``;

export const CardItems = styled.div`
  margin-top: 0.75rem;

  /* Space between rows; the drag library measures this wrapper, so the gap lives here */
  .item {
    padding-bottom: 0.5rem;
  }
`;

/* Compact dashed row after the list, same shape as the cards */
export const AddItemBox = styled.button`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 56px;
  font-family: Inter, sans-serif;
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--color-neutral-150);
  border: 1.5px dashed var(--color-neutral-base);
  border-radius: 12px;
  transition:
    color 0.15s,
    border-color 0.15s;

  &:hover:not(:disabled) {
    color: var(--color-neutral-white);
    border-color: var(--color-neutral-light);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
`;
